import { render, staticRenderFns } from "./IconPriority.vue?vue&type=template&id=44646b4a&"
import script from "./IconPriority.vue?vue&type=script&lang=ts&"
export * from "./IconPriority.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports